// src/components/Breadcrumb/Breadcrumb.jsx
import React from 'react';
import { ChevronRight, LayoutDashboard } from 'lucide-react';
import './Breadcrumb.css';

export default function Breadcrumb({ image, fileHistory, onSelectHistory }) {
  return (
    <div className="breadcrumb">
      <div className="bc-item bc-home">
        <LayoutDashboard size={12} />
        <span>Dashboard</span>
      </div>
      {image && (
        <>
          <ChevronRight size={12} className="bc-sep" />
          <div className="bc-item bc-active">
            <span>{image.name}</span>
          </div>
        </>
      )}
      {fileHistory.length > 1 && (
        <div className="bc-history">
          <span className="bc-hist-label">Recent</span>
          {fileHistory.slice(1, 4).map((f, i) => (
            <button key={i} className="bc-hist-item" onClick={() => onSelectHistory(f)}>
              {f.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
